import { localDateTime } from './solar.js';

export const clockMinutes = value => /^([01]\d|2[0-3]):[0-5]\d$/.test(value || '') ? Number(value.slice(0, 2)) * 60 + Number(value.slice(3)) : null;
export const minuteClock = value => `${String(Math.floor(value / 60)).padStart(2, '0')}:${String(value % 60).padStart(2, '0')}`;

// Daily wall-clock schedules repeat through a DST fold and skip nonexistent
// minutes at a spring transition. The scenario always carries an actual instant.
export function scheduledGroups(lighting, scenario) {
  const levels = { ...scenario.groupLevels }, issues = [];
  if (scenario.useSchedules === false) return { levels, issues };
  const minute = clockMinutes(localDateTime(scenario.timestamp, lighting.environment.timeZone).slice(11, 16));
  for (const schedule of lighting.schedules || []) {
    if (!schedule.enabled) continue;
    if (minute == null) { levels[schedule.group] = null; issues.push(`Set a condition time for the ${schedule.group} light schedule`); continue; }
    const start = clockMinutes(schedule.start), end = clockMinutes(schedule.end);
    const inside = start === end || (start < end ? minute >= start && minute < end : minute >= start || minute < end);
    // Group trim, schedule, fixture dimming and maintenance multiply. Master off
    // and disabled fixtures still win. Never mutate saved condition group levels.
    levels[schedule.group] = (levels[schedule.group] ?? 1) * (inside ? schedule.level : schedule.outsideLevel);
  }
  return { levels, issues };
}

export function timePreviewDocument(doc, timestamp) {
  const source = doc.lighting.scenarios.find(s => s.id === doc.lighting.activeId);
  if (!source || !Number.isFinite(Date.parse(timestamp))) return doc;
  const time = localDateTime(timestamp, doc.lighting.environment.timeZone).replace('T', ' ');
  const scenario = { ...source, timestamp, name: `${source.name} · ${time} · exploration`, required: false, basis: 'assumed' };
  return { ...doc, lighting: { ...doc.lighting, scenarios: [scenario] } };
}
